export const heroChecklist = [
  'Diagnóstico de fallas en disyuntores y térmicas.',
  'Soluciones para tomacorrientes, iluminación y circuitos.',
  'Diagnóstico de fallas complejas e instalaciones antiguas.',
  'Casos integrales de diagnóstico eléctrico profesional.',
  'Interpretación de situaciones reales mediante ejercicios simulados.',
  'Soluciones técnicas explicadas.',
  'Herramientas de consulta para trabajos domiciliarios.',
  'Recursos organizados para profesionales.',
];

export const problemCards = [
  {
    variant: 'blue' as const,
    title: '¿Y si tuvieras los diagnósticos y las soluciones organizados en un solo lugar?',
    paragraphs: [
      'Si trabajás de electricista, sabés que no todas las fallas son fáciles de identificar.',
      'A veces llegás a una vivienda donde un circuito dejó de funcionar y nadie sabe por qué.',
      'Otras veces el problema aparece solamente en determinados momentos, la instalación tiene modificaciones antiguas o los síntomas no permiten identificar inmediatamente la causa.',
      'Y ahí empiezan las dudas:',
      '¿Dónde puede estar el problema?',
      '¿Qué componente podría estar fallando?',
      '¿Qué información necesito para confirmar el diagnóstico?',
      '¿Cómo interpreto los resultados de las mediciones?',
      '¿Qué solución corresponde aplicar?',
      'En lugar de depender de información dispersa, explicaciones incompletas o apuntes desorganizados, COMBO COMPLETO ELECTRICISTAS reúne casos desarrollados y herramientas profesionales para consultar cuando los necesites.',
      'Encontrá ejemplos de fallas, diagramas, mediciones simuladas, criterios de diagnóstico y soluciones técnicas explicadas.',
    ],
    highlight: 'Identificá. Analizá. Diagnosticá. Resolvé.',
  },
  {
    variant: 'gold' as const,
    title: 'Dejá de perder tiempo buscando cómo interpretar cada falla eléctrica.',
    paragraphs: [
      'Tu tiempo debería estar dedicado a realizar diagnósticos, preparar trabajos y atender a tus clientes, no a buscar información técnica en distintos lugares cada vez que aparece un problema.',
      'Porque una cosa es realizar una instalación. Y otra muy diferente es encontrar por qué dejó de funcionar.',
      'Un cliente te llama porque una parte de la casa se quedó sin electricidad. Otro necesita saber por qué una instalación presenta problemas intermitentes.',
      'En una vivienda antigua encontrás circuitos que no están identificados. Y en otro trabajo necesitás interpretar un plano, evaluar resultados o preparar un informe técnico.',
      'Para esas situaciones creamos COMBO COMPLETO ELECTRICISTAS.',
      'Un sistema con cuatro tomos principales que desarrollan casos técnicos y cuatro bonos con herramientas para interpretar diagramas, analizar mediciones, documentar diagnósticos y preparar presupuestos.',
    ],
    highlight: 'Menos improvisación. Más organización profesional.',
  },
  {
    variant: 'navy' as const,
    title: 'Menos tiempo buscando información. Más soluciones prácticas a tu alcance.',
    paragraphs: [
      '¿Necesitás analizar una falla de un disyuntor diferencial?',
      'Encontrá casos prácticos con síntomas, posibles causas, datos simulados y diagnósticos explicados.',
      '¿Tenés dudas sobre un circuito de iluminación o un tomacorriente?',
      'Consultá ejemplos de problemas concretos y sus soluciones técnicas.',
      '¿Estás trabajando con una instalación antigua?',
      'Accedé a situaciones relacionadas con conductores deteriorados, modificaciones, conexiones y fallas difíciles de localizar.',
      '¿Necesitás interpretar un diagrama, registrar mediciones o presentar un presupuesto?',
      'También tenés herramientas organizadas para esas tareas.',
    ],
    highlight: 'Abrí el sistema. Buscá el problema. Consultá el caso. Aplicá tu criterio profesional.',
  },
];

export const benefits = [
  { title: 'Casos de fallas con soluciones explicadas', text: 'Consultá problemas eléctricos concretos, con síntomas, datos técnicos y diagnósticos razonados.' },
  { title: 'Herramientas profesionales de trabajo', text: 'Utilizá recursos para interpretar diagramas, documentar problemas y organizar presupuestos.' },
  { title: '4 áreas esenciales en un solo sistema', text: 'Disyuntores, circuitos domiciliarios, instalaciones complejas y diagnóstico integral.' },
  { title: 'Material de consulta reutilizable', text: 'Volvé a consultar los casos, diagramas y herramientas cuando necesites repasar una situación de trabajo.' },
  { title: 'Todo organizado en un solo lugar', text: 'Evitá depender exclusivamente de apuntes dispersos, búsquedas en internet y documentación desorganizada.' },
  { title: 'Menos tiempo preparando recursos', text: 'Encontrá ejemplos y herramientas organizadas para dedicar más atención al diagnóstico y a la planificación de cada intervención.' },
];

export const offerVolumes = [
  'Tomo 1 — Diagnóstico de Fallas en Disyuntores y Térmicas',
  'Tomo 2 — Fallas en Tomacorrientes, Iluminación y Circuitos',
  'Tomo 3 — Fallas Complejas e Instalaciones Antiguas',
  'Tomo 4 — Diagnóstico Eléctrico Profesional',
];

export const offerBonuses = [
  'Bono 1 — Guía Profesional de Diagramas Eléctricos',
  'Bono 2 — Manual Profesional de Mediciones Eléctricas',
  'Bono 3 — Fichas Profesionales de Diagnóstico',
  'Bono 4 — Presupuestos y Costos de Reparaciones Eléctricas',
];

export const offerPerks = ['Acceso digital inmediato', 'Material en español argentino', 'Pago único', '4 tomos + 4 bonos'];

export const recentBuyers = [
  { name: 'Martín Gómez', place: 'Córdoba Capital, Córdoba', minutes: 3 },
  { name: 'Javier Ruiz', place: 'Rosario, Santa Fe', minutes: 7 },
  { name: 'Carlos Benítez', place: 'Mar del Plata, Buenos Aires', minutes: 12 },
  { name: 'Nicolás Ferreyra', place: 'San Miguel de Tucumán, Tucumán', minutes: 5 },
  { name: 'Pablo Medina', place: 'Godoy Cruz, Mendoza', minutes: 9 },
  { name: 'Hernán Sosa', place: 'Neuquén Capital, Neuquén', minutes: 14 },
  { name: 'Ricardo Acosta', place: 'Salta Capital, Salta', minutes: 4 },
  { name: 'Leandro Díaz', place: 'Posadas, Misiones', minutes: 11 },
  { name: 'Gustavo Romero', place: 'Paraná, Entre Ríos', minutes: 8 },
  { name: 'Federico Molina', place: 'Bahía Blanca, Buenos Aires', minutes: 16 },
];
